import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BundleModeState {
  // Whether bundle mode is enabled (true) or browser route mode (false)
  isBundleMode: boolean;

  // Currently active bundle app name (if any)
  activeBundleApp: string | null;

  // Toggle bundle mode
  toggleBundleMode: () => void;

  // Set bundle mode
  setBundleMode: (enabled: boolean) => void;

  // Set active bundle app
  setActiveBundleApp: (appName: string | null) => void;
}

export const useBundleModeStore = create<BundleModeState>()(
  persist(
    (set) => ({
      isBundleMode: false, // Default to browser mode for proper path navigation
      activeBundleApp: null,

      toggleBundleMode: () => set((state) => ({ isBundleMode: !state.isBundleMode })),

      setBundleMode: (enabled: boolean) => set({ isBundleMode: enabled }),

      setActiveBundleApp: (appName: string | null) => {
        // Set the global flag IMMEDIATELY so auth redirect checks see it
        // before the bundle JS downloads and calls mount().
        // This prevents a race where background auth redirects to /login
        // while the bundle is still loading.
        if (appName) {
          (window as any).__ROOM_BUNDLE_MODE__ = true;
        }
        set({ activeBundleApp: appName });
      },
    }),
    {
      name: 'room-bundle-mode',
      partialize: (state) => ({ isBundleMode: state.isBundleMode }),
    }
  )
);
